<!-- @veltra/icons generated sha256:9e319ad968f0873e gen:8 source:src/svg/normal/moon.svg -->
<script setup lang="ts">
defineOptions({ name: 'Moon' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.333"
    viewBox="0 0 24 24"
  >
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9" />
  </svg>
</template>
